import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import simplebar from 'simplebar-vue';
import VueMarkdown from 'vue-markdown'
import App from './App'
import router from './router'
import HH from './logic/logic' // adds everything to window too

Vue.config.productionTip = false

//console.log('Adding global components...')
Vue.component('simplebar', simplebar);
Vue.component('VueMarkdown', VueMarkdown);

const requireComponent = require.context('./components', false, /[A-Z]\w+\.(vue|js)$/)
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = upperFirst(camelCase(fileName.split('/').pop().replace(/\.\w+$/, '')))
  //console.log('Adding component', componentName);
  Vue.component(componentName, componentConfig.default || componentConfig)
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
